import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsmedia',
	templateUrl:'./BSMediaPluginCompPage.html',
	styles: [],
	styleUrls:['./BSMediaPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSMediaPluginCompPage
{
	mdContent_834 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.media.BSMedia;
\`\`\``;
	mdContent_835 = `\`\`\`java
BSMedia()
\`\`\``;
	mdContent_836 = `\`\`\`java
BSMedia&lt;?&gt; media = new BSMedia&lt;&gt;();
media.setImageUrl("/img/avatar.jpg");
media.add(new H5&lt;&gt;().setText("Media Heading"));
media.add(new Paragraph&lt;&gt;().setText("Descriptive text."));
\`\`\``;
}
